<template>
	<div v-if="data.length != 0" class="c-facts">
		<ul
			class="
				justify-between
				mt-50
				border-t border-blue border-opacity-10
				text-14
				>=768:text-16 >=768:flex >=768:border-0
			"
		>
			<li
				v-for="item in data.slice(0, tooManyFacts())"
				:key="item.key"
				class="border-b border-blue border-opacity-10 >=768:border-0"
			>
				<span
					class="
						mt-15
						>=768:mt-0
						block
						text-action
						uppercase
						font-bold
						leading-initial
					"
					v-html="item.key"
				></span>
				<span
					class="leading-initial block mb-15 mt-8 >=768:mb-0"
					v-html="item.value"
				></span>
			</li>
			<li v-if="data.length > 4">
				<button
					v-tracking="`Facts, Click, ${getPath}`"
					class="
						flex
						items-center
						block
						text-blue
						font-bold
						mt-15
						uppercase
						>=768:mt-0
					"
					@click="onShow()"
				>
					<span class="leading-initial mr-20">{{
						seeAllFactsTitle
					}}</span>
					<SvgLinkCaret class="w-8 h-12" />
				</button>
			</li>
		</ul>
		<Portal v-if="isOpen" to="SpaOverlay">
			<div
				class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30"
				@click="onClose(index)"
			>
				<div
					class="
						fixed
						top-0
						right-0
						w-full
						h-full
						bg-white
						z-20
						px-20
						py-100
						>=768:w-half >=768:py-130 >=768:px-100
					"
					@click.stop
				>
					<button
						class="
							absolute
							top-30
							right-20
							>=768:top-33 >=768:right-33
							rounded-full
							bg-blue
							text-white
							z-20
							w-48
							h-48
							flex
							justify-center
							items-center
							transform
							hover:rotate-180
							transition
							duration-500
							ease-in-out
						"
						@click="onClose(index)"
					>
						<SvgClose class="w-12 h-12" />
					</button>
					<h2 class="uppercase font-bold text-24">
						{{ factsTitle }}
					</h2>
					<ul
						class="
							justify-between
							mt-50
							border-t border-blue border-opacity-10
							>=768:flex >=768:flex-wrap >=768:border-0
						"
					>
						<li
							v-for="(fact, i) in data"
							:key="i"
							class="
								border-b border-blue border-opacity-10
								w-full
								>=768:border-0 >=768:w-half >=768:mb-50
							"
						>
							<span
								class="
									mt-15
									>=768:mt-0
									block
									text-action
									uppercase
									font-bold
									leading-initial
								"
								v-html="fact.key"
							></span>
							<span
								class="
									leading-initial
									block
									mb-15
									mt-8
									>=768:mb-0
								"
								v-html="fact.value"
							></span>
						</li>
					</ul>
				</div>
			</div>
		</Portal>
		<CrawlerOnly v-if="data && data.length > 4">
			<section>
				<h2>{{ factsTitle }}</h2>
				<ul>
					<li v-for="(fact, i) in data" :key="i">
						<strong v-html="fact.key"></strong>
						<span v-html="fact.value"></span>
					</li>
				</ul>
			</section>
		</CrawlerOnly>
	</div>
</template>

<script>
import SvgLinkCaret from '~/assets/svgs/link-caret.svg?inline';
import SvgClose from '~/assets/svgs/close.svg?inline';
import CrawlerOnly from '~/components/main/CrawlerOnly';

export default {
	name: 'Facts',

	components: {
		SvgClose,
		SvgLinkCaret,
		CrawlerOnly,
	},

	props: {
		data: Array,
	},

	data() {
		return {
			isOpen: false,
			index: 0,
		};
	},

	computed: {
		getPath() {
			return this.$store.state.route.fullPath;
		},
		seeAllFactsTitle() {
			if (this.$store.state.site.id === 1231) {
				return 'Se alle fakta';
			} else {
				return 'See all facts';
			}
		},
		factsTitle() {
			if (this.$store.state.site.id === 1231) {
				return 'Fakta';
			} else {
				return 'Facts';
			}
		},
	},

	created() {
		this.$on('overlay.close', this.onClose);
	},

	methods: {
		onClose() {
			this.isOpen = false;
		},
		onShow(index) {
			this.index = index;
			this.isOpen = true;
		},
		tooManyFacts() {
			const factsLimit = 4;
			return this.data.length > factsLimit ? 3 : this.data.length;
		},
	},
};
</script>
